var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctChoiceCards\" ng-class=\"{ 'sctChoiceCards-disabled': vm.disabled }\">\n<div ng-repeat=\"item in vm.options\" class=\"sctChoiceCards_card\" ng-class=\"{ active: item.selected && !vm.disabled, 'sctChoiceCards_card-vertical': vm.settings.view === 'vertical' }\" ng-click=\"!vm.disabled && vm.select(item)\">\n<div class=\"sctChoiceCards_active\">&nbsp;</div>\n<div class=\"sctChoiceCards_title\">{{ item.title }}</div>\n<div class=\"sctChoiceCards_description\">\n{{ ::item.description }}\n</div>\n</div>\n</div>";
var id1="sct/sctChoiceCards/sctChoiceCards.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctChoiceCards/sctChoiceCards.html
// module id = 1281
// module chunks = 1